package com.tovtalk.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Immutable
data class TovTalkSpacingSystem(
    val none: Dp,
    val xxxs: Dp,
    val xxs: Dp,
    val xs: Dp,
    val sm: Dp,
    val md: Dp,
    val lg: Dp,
    val xl: Dp,
    val xxl: Dp,
    val xxxl: Dp,
    val screenPadding: Dp,
    val cardPadding: Dp,
    val listItemPadding: Dp,
    val iconPadding: Dp,
    val buttonPadding: Dp,
    val inputPadding: Dp,
    val topBarHeight: Dp,
    val bottomNavHeight: Dp,
    val fabSpacing: Dp,
)

val TovTalkSpacing = TovTalkSpacingSystem(
    none = 0.dp,
    xxxs = 2.dp,
    xxs = 4.dp,
    xs = 8.dp,
    sm = 12.dp,
    md = 16.dp,
    lg = 24.dp,
    xl = 32.dp,
    xxl = 48.dp,
    xxxl = 64.dp,
    screenPadding = 16.dp,
    cardPadding = 16.dp,
    listItemPadding = 12.dp,
    iconPadding = 8.dp,
    buttonPadding = 16.dp,
    inputPadding = 16.dp,
    topBarHeight = 56.dp,
    bottomNavHeight = 64.dp,
    fabSpacing = 16.dp,
)

@Immutable
data class TovTalkSizeSystem(
    val iconXs: Dp,
    val iconSm: Dp,
    val iconMd: Dp,
    val iconLg: Dp,
    val iconXl: Dp,
    val iconXxl: Dp,
    val avatarXs: Dp,
    val avatarSm: Dp,
    val avatarMd: Dp,
    val avatarLg: Dp,
    val avatarXl: Dp,
    val avatarXxl: Dp,
    val avatarProfileHeader: Dp,
    val buttonHeightSm: Dp,
    val buttonHeightMd: Dp,
    val buttonHeightLg: Dp,
    val minTouchTarget: Dp,
    val thumbnailSm: Dp,
    val thumbnailMd: Dp,
    val thumbnailLg: Dp,
    val videoActionButton: Dp,
    val videoProgressBar: Dp,
    val borderWidth: Dp,
    val videoPlayButtonSize: Dp,
    val videoPlayIconSize: Dp,
    val emptyStateIconSize: Dp,
    val dragHandleWidth: Dp,
    val dragHandleHeight: Dp,
    val progressBarHeight: Dp,
    val miniPlayerHeight: Dp,
    val miniPlayerThumbnail: Dp,
    val dividerThickness: Dp,
    val loadingStrokeWidth: Dp,
    val loadingIndicatorSm: Dp,
    val loadingIndicatorMd: Dp,
    val loadingIndicatorLg: Dp,
    val edgeSwipeZone: Dp,
    val blurRadius: Dp,
)

val TovTalkSizes = TovTalkSizeSystem(
    iconXs = 16.dp,
    iconSm = 20.dp,
    iconMd = 24.dp,
    iconLg = 32.dp,
    iconXl = 40.dp,
    iconXxl = 48.dp,
    avatarXs = 24.dp,
    avatarSm = 32.dp,
    avatarMd = 40.dp,
    avatarLg = 56.dp,
    avatarXl = 80.dp,
    avatarXxl = 120.dp,
    avatarProfileHeader = 72.dp,
    buttonHeightSm = 32.dp,
    buttonHeightMd = 44.dp,
    buttonHeightLg = 56.dp,
    minTouchTarget = 48.dp,
    thumbnailSm = 64.dp,
    thumbnailMd = 96.dp,
    thumbnailLg = 160.dp,
    videoActionButton = 40.dp,
    videoProgressBar = 3.dp,
    borderWidth = 2.dp,
    videoPlayButtonSize = 72.dp,
    videoPlayIconSize = 36.dp,
    emptyStateIconSize = 64.dp,
    dragHandleWidth = 36.dp,
    dragHandleHeight = 4.dp,
    progressBarHeight = 6.dp,
    miniPlayerHeight = 72.dp,
    miniPlayerThumbnail = 56.dp,
    dividerThickness = 0.5.dp,
    loadingStrokeWidth = 3.dp,
    loadingIndicatorSm = 20.dp,
    loadingIndicatorMd = 32.dp,
    loadingIndicatorLg = 48.dp,
    edgeSwipeZone = 28.dp,
    blurRadius = 24.dp,
)

@Immutable
data class TovTalkRadiusSystem(
    val none: Dp,
    val xs: Dp,
    val sm: Dp,
    val md: Dp,
    val lg: Dp,
    val xl: Dp,
    val full: Dp,
)

val TovTalkRadius = TovTalkRadiusSystem(
    none = 0.dp,
    xs = 4.dp,
    sm = 8.dp,
    md = 12.dp,
    lg = 16.dp,
    xl = 24.dp,
    full = 999.dp,
)

val LocalTovTalkSpacing = staticCompositionLocalOf { TovTalkSpacing }
val LocalTovTalkSizes = staticCompositionLocalOf { TovTalkSizes }
val LocalTovTalkRadius = staticCompositionLocalOf { TovTalkRadius }
